import { ChertoExperiments } from 'constants/experiments'
import SocialProofDialog from 'components/OfferPage/SocialProofDialog'
import useExperiment from 'hooks/Experiments/useExperiment'
import { SOCIAL_PROOF_COPY_VARIANTS } from 'hooks/OfferPage/useSocialProofPopup'
import { useRecentOfferPurchases } from 'hooks/OfferPage/useRecentOfferPurchases'

interface Props {
  offer: App.Offer
}

function FlashHotelSocialProofDialog({ offer }: Props) {
  const { isTurnedOn: isSocialProofExperimentOn } = useExperiment(
    ChertoExperiments.croSocialProofRecentPurchase,
    { canActivate: false },
  )
  const recentPurchases = useRecentOfferPurchases(offer.id, 'hotel', isSocialProofExperimentOn)

  return (
    <SocialProofDialog
      copyVariant={SOCIAL_PROOF_COPY_VARIANTS.flashHotel}
      experiment={ChertoExperiments.croSocialProofRecentPurchase}
      offerImage={offer.image}
      recentPurchases={recentPurchases}
    />
  )
}

export default FlashHotelSocialProofDialog
